import { TextField, Button, FormControl, Grid } from '@mui/material';

import { CustomAutocomplete, LinearLoading } from 'common'

export const LawyerLogForm = ({ useFetchInit, readOnlyMode }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { LawyerLogsForm } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = LawyerLogsForm
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const { onSubmitLawyerLog, handleClickResetLawyerLogForm } = Actions

    return (
        <>
        
            <div className='h4 mt-1 mb-1'>
                {formState.idlawyerlogs > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>

            <div className="pt-2"></div>
            <form onSubmit={onSubmitLawyerLog}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="date_log">* Fecha</label>
                            <TextField
                                id="date_log"
                                name="date_log"
                                value={formState.date_log}
                                onChange={onInputChange}
                                size='small'
                                type="date"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="observations">Observaciones</label>
                            <TextField
                                id="observations"
                                name="observations"
                                value={formState.observations}
                                onChange={onInputChange}
                                // label='Modelo'
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button
                                style={{background: "#4b4b4c"}}
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                            </Button>
                            &nbsp; &nbsp;
                            <Button 
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                type="button"
                                variant="contained"
                                onClick={handleClickResetLawyerLogForm}
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
